module.exports = __webpack_public_path__ + "static/media/adv-banner-img2.fc5b92aa.png";